export const types = {
  FETCHINGTEMPLATEJSON: 'AWSASYNC.FETCHINGJSON',
  FETCHEDTEMPLATEJSON: 'AWSASYNC.FETCHEDJSON',
  FETCHTEMPLATEJSONFAILED: 'AWSASYNC.FETCHJSONFAILED'
};

export const fetchingTemplateJSON = () => ({
  type: types.FETCHINGTEMPLATEJSON
});

export const fetchedTemplateJSON = data => ({
  type: types.FETCHEDTEMPLATEJSON,
  data: data
});

export const fetchTemplateJSONFailed = () => ({
  type: types.FETCHTEMPLATEJSONFAILED
});



// WEBPACK FOOTER //
// ./src/store/actions/s3Templates.js